<template>
  <div id="scaleDetailView">
    <div v-if="$route.name === 'scale'">
      <h1>{{ $t('privatePage.scale_header') }}</h1>
      <b-tabs v-model="tabIndex">
        <b-tab :title="$t('privatePage.details')" active class="tabContent">
          <scale-detail-editor :currentScale="currentScale" v-on:onEdit="onEdit">
          </scale-detail-editor>
        </b-tab>
        <b-tab :title="$t('privatePage.scale_langDetail_header')" class="tabContent" v-show="currentScaleContent && currentScaleContent.languageId">
          <scale-lang-detail-editor :currentScale="currentScale">
          </scale-lang-detail-editor>
        </b-tab>
      </b-tabs>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ScaleDetailEditor from '../../components/scales/scaledetaileditor'
import ScaleLangDetailEditor from '../../components/scales/scalelangdetaileditor'

export default {
  components: {
    ScaleDetailEditor,
    ScaleLangDetailEditor
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  computed: {
    ...mapGetters('scalesModule', ['currentScale', 'currentScaleContent']),
    ...mapGetters('testMethodsModule', ['questionFormats'])
  },
  methods: {
    ...mapActions('scalesModule', {
      selectCurrentScaleContent: 'selectCurrentScaleContent'
    }),
    onEdit: function() {
      this.tabIndex = 1
    },
    onTabInput: function(e) {}
  },
  created() {
    this.selectCurrentScaleContent({})
  }
}
</script>

<style>
.tabContent {
  margin-top: 30px;
}
</style>
